
      export interface PossibleTypesResultData {
        possibleTypes: {
          [key: string]: string[]
        }
      }
      const result: PossibleTypesResultData = {
  "possibleTypes": {
    "ContingencyResult": [
      "Contingency",
      "ContingencyError"
    ],
    "GetPropertyDetailsResult": [
      "GetPropertyDetailsFailed",
      "GetPropertyDetailsSuccess"
    ],
    "KeyTermMetadata": [
      "KeyTermCalculatedMetadata",
      "KeyTermUserOverrideMetadata"
    ],
    "KeyTermResult": [
      "KeyTerm",
      "KeyTermError"
    ],
    "MarketDataSource": [
      "CompsSource",
      "IndigoOffersSource",
      "MLSSource"
    ],
    "NotificationLogInterface": [
      "TransactionNotificationLogObject"
    ],
    "OfferScoreResult": [
      "OfferScore",
      "OfferScoreNotCalculated"
    ],
    "OrganizationPartnerContactUnion": [
      "InsuranceAgentContactObject",
      "LoanOfficerContactObject",
      "TitleAgentContactObject"
    ],
    "PartnerContactBaseObject": [
      "InsuranceAgentContactObject",
      "LoanOfficerContactObject",
      "TitleAgentContactObject"
    ],
    "Table": [
      "TableData"
    ],
    "TableRowData": [
      "OffersByFinancingTypeTableRow"
    ],
    "ValidationReportDataFields": [
      "InternalValidationReportDataObject",
      "ValidationReportDataObject"
    ]
  }
};
      export default result;
    